import { TimeZone } from "src/app/shared/models/time-zone.model";

export interface CurrencyData {
  id: number;
  country: string;
  currency: string;
  symbol: string;
}

export interface Country {
  id: number;
  name: string;
  code: string;
}

export interface State {
  id: number;
  country: Country;
  name: string;
}

export interface City {
  id: number;
  state: State;
  name: string;
}

export interface Reseller {
  id: number;
  name: string;
}

export interface Role {
  role_id: number;
  role_name: string;
  role_field: string;
}

export interface Currency {
  id: number;
  country: string;
  currency: string;
  symbol: string;
}

export interface Balance {
  balance: number;
  currency: Currency;
}

export interface Profile {
  id: number;
  username: string;
  name: string;
  city: City;
  phone: string;
  post_code: string;
  address: string;
  company: string;
  company_logo: string;
  is_legal: boolean;
  active: boolean;
  reseller: Reseller;
  whatsapp: string;
  role: Role;
  balance: number;
  balances: Balance[];
  timezone_data: TimeZone;
  code: string;
  print_access: boolean;
  office: string;
  documents: any[];
  google_two_step_activation: boolean;
  phone_confirmed: boolean;
  whatsapp_confirmed: boolean;
}

export interface Payment {
  id: number;
  payment_type: number;
  payment_type_text: string;
  payment_method: number;
  payment_method_text: string;
  amount: number;
  reference_code: string;
  invoice_number: string;
  currency_data: CurrencyData;
  extra_data: string;
  payment_date: string;
  description: string;
  is_confirm: boolean;
  profile: Profile;
}

export interface Payments {
  count: number;
  next?: any;
  previous?: any;
  results: Payment[];
}

export interface Type {
  type_id: number;
  type_name: string;
}

export interface Status {
  status_id: number;
  status_name: string;
}

export interface Gateway {
  id: number;
  title: string;
  logo?: any;
  online_gateway: number;
  description: string;
}

export enum PaymentGateways {
  "PAYPAL" = 1,
  "BITPAY" = 2,
  "NGENIUS" = 3,
  "HIGIFT" = 4,
  "MONEY_CHANGER" = 5,
  "CHEQUE" = 6,
  "JPMORGAN_HPS" = 7,
  "PAYTAB" = 8,
  "EZPIN_PAYMENT" = 9,
  "PAYPAL_EMAIL_ERROR" = "1009",
}

export enum HiGiftStatus {
  "ACTIVE" = "02",
  "INACTIVE" = "03",
  "INVALID" = "04",
  "REDEEMED" = "05",
  "EXPIRED" = "08",
}

export interface OnlinePayment {
  id: number;
  user: User;
  transaction_id: string;
  gateway_data: Gatewaydata;
  currency_data: Currencydata;
  status: number;
  created_time: string;
  info?: any;
}

interface Currencydata {
  id: number;
  country: string;
  currency: string;
  symbol: string;
}

interface Gatewaydata {
  id: number;
  title: string;
  logo?: any;
  online_gateway: number;
  description: string;
}

interface User {
  id: number;
  username: string;
  name: string;
  admin?: Admin;
  reseller?: any;
  role: Role;
  code: string;
  company: string;
  is_reseller: boolean;
}

export enum ActivityTypes {
  PAYMENT_REFUND = 4,
  PAYMENT = 1,
  CREDIT = 5,
  CREDIT_REFUND = 7,
}

export interface OnlinePaymentList {
  count: number;
  next?: any;
  previous?: any;
  results: Result[];
}

interface Result {
  id: number;
  user: User;
  transaction_id: string;
  gateway_data: Gatewaydata;
  currency_data: Currencydata;
  amount: number;
  fee?: number;
  net_amount?: number;
  status: number;
  status_text: string;
  payment_status: number;
  payment_status_text: string;
  created_time: string;
}

interface Currencydata {
  id: number;
  country: string;
  currency: string;
  symbol: string;
}

interface Admin {
  id: number;
  name: string;
  company: string;
}

export interface ExchangeRate {
  from_currency_data: Currency;
  to_currency_data: Currency;
  rate: number;
}

export interface ExchangeRequest {
  id: number;
  user: User;
  from_currency_data: Currency;
  to_currency_data: Currency;
  rate: number;
  amount: number;
  created_time: string;
  error?: any;
  is_done: boolean;
}

export interface ExchangeHistoryList {
  count: number;
  next?: any;
  previous?: any;
  results: ExchangeHistory[];
}

interface ExchangeHistory {
  id: number;
  user: User;
  from_currency_data: Currency;
  to_currency_data: Currency;
  rate: number;
  amount: number;
  created_time: string;
  error?: any;
  is_done: boolean;
}

export interface UserPaymentEmailList {
  count: number;
  next?: any;
  previous?: any;
  results: UserPaymentEmail[];
}

export interface UserPaymentEmail {
  id: number;
  user_id: number;
  user_data: Userdata;
  email: string;
}

interface Userdata {
  id: number;
  username: string;
  name: string;
  admin: Admin;
  reseller: Admin;
  role: Role;
  code: string;
  company: string;
  is_reseller: boolean;
}

interface Admin {
  id: number;
  name: string;
  company: string;
}
